(() => {
if(window.FloraGift)return;
const el=document.getElementById('flora-real-gift');
if(!el)return;
const config=JSON.parse(el.textContent);
const root=window.Shopify?.routes?.root||'/';
let queue=Promise.resolve();
async function request(path,body){
const response=await fetch(root+path,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
const data=await response.json();
if(!response.ok||data.status||data.errors)throw Error(data.description||data.message||'Unable to confirm your complimentary gift. Please try again.');
return data;
}
function cartFromSections(sections){
const html=sections?.['cart-drawer'];
if(typeof html!=='string')return null;
try{
const node=new DOMParser().parseFromString(html,'text/html').querySelector('[data-flora-cart-state]');
const cart=node?JSON.parse(node.textContent):null;
return Array.isArray(cart?.items)?cart:null;
}catch{return null;}
}
async function run(cart,sectionIds=[]){
if(!config.enabled)return {cart,sections:null};
cart=cart?.items?cart:await request('cart.js');
const variant=Number(config.variant);
const gifts=cart.items.filter(i=>Number(i.variant_id)===variant);
const eligible=cart.items.some(i=>Number(i.variant_id)!==variant&&i.original_price>0&&!i.gift_card);
const want=eligible&&config.available&&config.price===0;
const ids=[...new Set(sectionIds)].slice(0,5);
const sectionArgs={sections:ids,sections_url:location.pathname};
let sections=null;
const updates={};
gifts.forEach((g,i)=>{const quantity=want&&i===0?1:0;if(g.quantity!==quantity)updates[g.key]=quantity;});
if(Object.keys(updates).length){
cart=await request('cart/update.js',{updates,...sectionArgs});
sections=cart.sections||null;
}
if(want&&!gifts.length){
const added=await request('cart/add.js',{items:[{id:variant,quantity:1,properties:{_flora_gift:'true'}}],...sectionArgs});
sections=added.sections||null;
cart=cartFromSections(added.sections)||await request('cart.js');
}
return {cart,sections};
}
window.FloraGift={
cartFromSections,
sync(cart,ids){const next=queue.then(()=>run(cart,ids));queue=next.catch(()=>{});return next;},
async refresh(){
const result=await this.sync(null,['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer']);
if(!result.sections)return;
for(const [id,selector] of [['cart-drawer','#CartDrawer'],['cart-icon-bubble','#cart-icon-bubble'],['main-cart-items','#main-cart-items .js-contents'],['main-cart-footer','#main-cart-footer .js-contents']]){
const html=result.sections[id];if(!html)continue;
const doc=new DOMParser().parseFromString(html,'text/html');
const target=document.querySelector(selector);
const source=id==='cart-icon-bubble'?doc.querySelector('.shopify-section'):doc.querySelector(selector);
if(target&&source)target.innerHTML=source.innerHTML;
}
const drawer=document.querySelector('cart-drawer');
drawer?.classList.toggle('is-empty',result.cart.item_count===0);
if(result.sections['cart-drawer'])drawer?.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>drawer.close());
}
};
let checking=false;
async function checkout(event){
const button=event.target.closest('[name="checkout"],a[href="/checkout"],a[href^="/checkout?"]');
if(event.type==='click'&&!button)return;
if(event.type==='submit'&&event.submitter?.name!=='checkout')return;
event.preventDefault();event.stopImmediatePropagation();
if(checking)return;checking=true;
const target=button||event.submitter;target?.setAttribute('aria-busy','true');
try{
await window.FloraGift.sync();
location.assign(root+'checkout');
}catch(error){
let notice=document.getElementById('flora-gift-error');
if(!notice){notice=document.createElement('p');notice.id='flora-gift-error';notice.setAttribute('role','alert');target?.insertAdjacentElement('afterend',notice);}
notice.textContent=error.message;
}finally{checking=false;target?.removeAttribute('aria-busy');}
}
document.addEventListener('click',checkout,true);
document.addEventListener('submit',checkout,true);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>window.FloraGift.refresh().catch(()=>{}),{once:true});
else window.FloraGift.refresh().catch(()=>{});
})();
